import { IRequestPaginationData } from '@faire/web-api--source/indigofair/data/IRequestPaginationData';

export namespace IListBrandOrderGroupsRequest {
  /**
   * Return an instance of IListBrandOrderGroupsRequest with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IListBrandOrderGroupsRequest>
  ): IListBrandOrderGroupsRequest =>
    ({
      filter_keys: [],
      ...(partial ?? {}),
    }) as IListBrandOrderGroupsRequest;
}

/**
 * This request will replace ListOrdersRequest. It will be more general, and will
 * divide up the response by shipment instead of by order.
 */
export interface IListBrandOrderGroupsRequest {
  query: string | undefined;
  filter_keys: Array<string>;
  action_required_only: boolean | undefined;
  pagination_data: IRequestPaginationData | undefined;
}
